import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";

import theme from "@/theme";
import router from "@/router";
import "./index.css";

// HTML 언어 속성을 영어로 고정
if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", "en");
}

// 개발 환경에서는 타이틀에 [개발]을 붙입니다.
if (import.meta.env.VITE_NODE_ENV === "development") {
  document.title = `[개발] ${document.title}`;
}

// 개발 환경에서는 타이틀에 [개발]을 붙입니다.
if (import.meta.env.VITE_NODE_ENV === "local") {
  document.title = `[로컬] ${document.title}`;
}

// 배포 환경에서는 콘솔 로그를 끕니다.
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.time = () => {};
  console.timeEnd = () => {};
}

// ENV 설정 확인 후 API_URL이 없으면 페이지를 전환 합니다.
// if (!ENV.API_URL) {
//   router.push("/error/404");
// }
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);
